import React from 'react';
import {ThemeProvider} from "styled-components";
import {useServices} from "./hooks/use-services.hook";
import {observer} from "mobx-react";
import {AppLoadingIndicator} from "./app-loading-indicator";
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';


export const  App: React.FC = observer(() => {
    const services = useServices();
    return (
        <ThemeProvider theme={services.theme.currentTheme}>
            {services.theme.currentTheme.globalStyles}
            {
                services.isLoading
                    ?  (<AppLoadingIndicator>
                            {services.language.translate('Loading...')}
                        </AppLoadingIndicator>)
                    : (services.navigation.currentRoute.render())
            }

        </ThemeProvider>
    );
});

export default App;
